import React from 'react';
import PropTypes from 'prop-types';

import DealField, { propTypes } from './field';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export function SimpleDealField({ changeDeal, deal, invalid, label, name, required, type, ...props }) {
  return (
    <ManagedFormGroup
      autoComplete="off"
      hasError={invalid}
      label={label}
      name={name}
      required={required}
      type={type}
      value={deal[name]}
      onChange={changeDeal}
      {...props}
    />
  );
}

SimpleDealField.propTypes = {
  ...propTypes,
  type: PropTypes.oneOf(['currency', 'number', 'percentage', 'text', 'textarea']),
};

export default DealField(SimpleDealField);
